import React from "react";
import { Bot, Gamepad2, Globe, Cpu, Smartphone, Image, Layers, Lightbulb } from "lucide-react";

const ProjectsSection = () => {
  const projects = [
    {
      title: "AI Chatbot",
      description: "Build and train a conversational AI from scratch.",
      themeClass: "p-purple",
      delay: "delay-100",
      icon: <Bot />
    },
    {
      title: "Smart Robot",
      description: "Program a physical robot to navigate and respond to its environment.",
      themeClass: "p-orange",
      delay: "delay-200",
      icon: <Cpu />
    },
    {
      title: "2D Game",
      description: "Code a playable game using loops, logic and programming basics.",
      themeClass: "p-blue",
      delay: "delay-300",
      icon: <Gamepad2 />
    },
    {
      title: "Personal Website",
      description: "Design and publish your own website.",
      themeClass: "p-pink",
      delay: "delay-100",
      icon: <Globe />
    },
    {
      title: "Mobile App",
      description: "Build a working Android app and understand how apps are made.",
      themeClass: "p-green",
      delay: "delay-200",
      icon: <Smartphone />
    },
    {
      title: "AI Image Generator",
      description: "Learn how AI creates visuals, then build a simple model yourself.",
      themeClass: "p-indigo",
      delay: "delay-300",
      icon: <Image />
    },
    {
      title: "3D Design Project",
      description: "Design a 3D model and bring it to life with a 3D printer.",
      themeClass: "p-purple",
      delay: "delay-100",
      icon: <Layers />
    },
    {
      title: "STEM Innovation Project",
      description: "Solve a real-world problem using science and engineering.",
      themeClass: "p-blue",
      delay: "delay-200",
      icon: <Lightbulb />
    }
  ];

  return (
    <section className="section projects section-white" id="projects">
      <div className="container">
        <div className="section-header reveal-triggered fade-up active">
          <h2>Students Build <span className="text-gradient">Real-World Projects</span></h2>
          <p>Students don't just learn concepts — they create meaningful projects they can show, share and be proud of.</p>
        </div>

        <div className="projects-grid">
          {projects.map((project, index) => (
            <div key={index} className={`premium-card project-card ${project.themeClass} reveal-triggered fade-up ${project.delay} active`}>
              <div className="icon-box">
                {project.icon}
              </div>
              <div className="project-details">
                <h3>{project.title}</h3>
                <p>{project.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ProjectsSection;
